import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "../../shared/toastr.service";

@Component({
  selector: "app-success",
  templateUrl: "./success.component.html",
  styleUrls: ["./success.component.scss"],
  standalone: false,
})
export class BillingSuccessComponent implements OnInit {
  constructor(
    private router: Router,
    private translate: TranslateService,
    private toastr: ToastrService,
  ) {}

  ngOnInit(): void {
    this.translate
      .get("settings.billing.success.paymentSuccessAlert")
      .subscribe((translation: string) => {
        this.toastr.success(translation);
      });
  }

  backToBilling(): void {
    void this.router.navigate(["/settings/billing"]);
  }
}
